<template>
  <div class="home">
    <div class="helper-navbar"></div>
    <div class="title">
      <div class="caption">
        <div class="company-name">G&S Components <span>s.r.o.</span></div>
        <div class="company-description">{{ loc.home.slogan }}</div>
      </div>
      <ScrollAnchor href="#content" class="scroll-anchor"></ScrollAnchor>
    </div>
    <div id="content">
      <div class="cards">
        <ParallaxCard :data-image="productsImg">
          <h1 slot="header">{{ loc.home.cards.products.title }}</h1>
          <p slot="content">{{ loc.home.cards.products.brief }}</p>
        </ParallaxCard>
        <div class="card-extras odd">
          <span v-html="loc.home.cards.products.text"/>
          &nbsp;<router-link class="more" to="/production">{{ loc.home.cards.more }}</router-link>
        </div>
      </div>
      <div class="cards">
        <div class="card-extras even">
          {{ loc.home.cards.family.text }}
          <router-link class="more" to="/contact">{{ loc.home.cards.more }}</router-link>
        </div>
        <ParallaxCard :data-image="familyImg">
          <h1 slot="header">{{ loc.home.cards.family.title }}</h1>
          <p slot="content">{{ loc.home.cards.family.brief }}</p>
        </ParallaxCard>
      </div>
      <div class="cards">
        <ParallaxCard :data-image="clientsImg">
          <h1 slot="header">{{ loc.home.cards.clients.title }}</h1>
          <p slot="content">{{ loc.home.cards.clients.brief }}</p>
        </ParallaxCard>
        <div class="card-extras odd">
          {{ loc.home.cards.clients.text }}
        </div>
      </div>
      <ContactUs :caption="loc.home.contact.caption"/>
    </div>
  </div>
</template>

<script>
import ParallaxCard from "../components/ParallaxCard"
import ContactUs from "../components/ContactUs"
import ScrollAnchor from "../components/ScrollAnchor"

import img1 from "../assets/img1.jpg"
import img2 from "../assets/img2.jpg"
import img3 from "../assets/img3.jpg"

export default {
  name: "home",
  components: {
    ParallaxCard,
    ContactUs,
    ScrollAnchor,
  },
  data() {
    return {
      productsImg: img1,
      familyImg: img2,
      clientsImg: img3,
    }
  },
}
</script>

<style lang="less" scoped>
  @import "../styles/colors";
  @import "../styles/fonts";

  .home {
    height: 100%;
  }
  .title {
    background-image: url("../assets/title_image.jpg"), linear-gradient(to right, #00000052 10%, #ffffff00 100%);
    background-repeat: no-repeat;
    background-position: center top;
    background-size: cover;
    background-attachment: fixed;
    background-blend-mode: darken;
    height: 50vh;
    display: block;
    position: relative;
    z-index: 8;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .scroll-anchor {
    display: none;
    position: absolute;
    bottom: 0px;
    margin-bottom: 30px;
  }
  @media screen and (max-width: 500px) {
    .title {
      height: 101vh;
    }
    .scroll-anchor {
      display: block;
    }
  }
  .caption {
    width: auto;
    border: 1px @grey solid;
    background-color: rgba(255, 255, 255, 0.81);
    position: relative;
    text-align: center;
    z-index: 7;
    margin: auto;
  }
  .company-name {
    color: @blue;
    font-family: @title;
    letter-spacing: 5px;
    font-size: 50px;
    margin-top: 1vh;
    padding: 0 20px 0 20px;
  }
  .company-name span {
    font-size: 30px;
  }
  .company-description {
    color: @grey;
    font-size: 18px;
    margin-top: 1vh;
    letter-spacing: 1.5px;
    font-weight: lighter;
    font-family: @text;
    vertical-align: bottom;
    padding-bottom: 10px;
  }
  @media screen and (max-width: 700px) {
    .company-name {
      font-size: 35px;
    }
    .company-name span {
      font-size: 25px;
    }
    .company-description {
      font-size: 13px;
    }
  }
  @media screen and (min-width: 1000px) {
    .company-name {
      font-size: 72px;
    }
    .company-name span {
      font-size: 50px;
    }
    .company-description {
      font-size: 24px;
    }
  }
  .cards {
    margin-top: 10px;
    padding: 30px 80px;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
  }
  #content {
    min-height: 100%;
  }
  .card-extras {
    display: block;
    position: relative;
    align-self: center;
    width: 30vw;
  }
  @media screen and (max-width: 715px) {
    .card-extras {
      padding-top: 50px;
      padding-bottom: 50px;
    }
    .odd {
      padding-left: 10px !important;
      margin-left: 0px !important;
      width: 80%;
    }

    .even {
      padding-right: 10px !important;
      margin-right: 0px !important;
      width: 80%;
    }
  }
  .odd {
    border-left: solid @dark 1px;
    padding-left: 40px;
    margin-left: 40px;
  }

  .even {
    border-right: solid @dark 1px;
    padding-right: 40px;
    margin-right: 40px;
  }

  .more {
    display: contents;
    font-weight: 500;
    color: @blue;
  }

  .helper-navbar {
    position: fixed;
    height: 60px;
    top: 0px;
    width: 100%;
    background-color: @blue;
    z-index: 5;
  }
</style>
